// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip__tooltip--3Z9","action":"Tooltip__action--2o-","balloon":"Tooltip__balloon--2mD","icon":"Tooltip__icon--Pan","content":"Tooltip__content--VjV"};